import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './AnnounceBanner.module.less';
import { ArrowRightOutlined } from '@ant-design/icons';

export default function AnnounceBanner() {
	const location = useLocation();
	const [current, setCurrent] = useState(location.pathname);
	const history = useHistory();

	const handleClick = (e: any) => {
		setCurrent(e.key);
		history.push(e.key);
	};

	useEffect(() => {
		setCurrent(location.pathname);
	}, [location, current]);

	return (
		<>
			<div className={styles.topBanner}>
				<p>
					<b>Meta Quest Developers:</b> Integrating Omni movement into your game?
					<a href="https://meta-developers.virtuix.com/" className={styles.bannerButton}>
						Go to Meta Developers Portal <ArrowRightOutlined />
					</a>
				</p>
			</div>
		</>
	);
}
